const notificationComposition = () => {
  const nuxtApp = useNuxtApp()
  const { $store: store, $i18n: i18n, $dayjs } = nuxtApp

  const getFlashNotification = ({ flashTime, timeType }) => {
    let flashText = i18n.t('tag_flash_sale_now')
    switch (timeType) {
      case 'day': {
        const date = $dayjs(flashTime).format('MM/DD')
        flashText = i18n.t('tag_flash_sale_time', [date])
        break
      }
      case 'hour': {
        const time = $dayjs(flashTime).format('HH:mm')
        flashText = i18n.t('tag_flash_sale_time', [time])
        break
      }
    }
    return { type: 'flash', icon: 'tag-icon.svg', color: 'purple50', text: flashText }
  }

  const getGroupNotification = ({ bookingTime, nickname }) => {
    const isExpired = $dayjs(bookingTime).isBefore($dayjs())
    const bookingDateTime = $dayjs(bookingTime).format('YYYY/MM/DD HH:mm')
    const groupText = isExpired
      ? i18n.t('group_order_expired_modal_title', { name: nickname })
      : i18n.t('group_invitation', { name: nickname, time: bookingDateTime })
    return { type: 'grouping', icon: false, color: 'yellow50', text: groupText }
  }

  const getDeliveryNotification = ({ freeAmount }) => {
    const deliveryText = i18n.t('product_delivery_bar', { threshold: freeAmount })
    return { type: 'delivery', icon: 'motorcycle.svg', color: 'orange50', text: deliveryText }
  }

  const getGiftNotification = ({ nickname }) => {
    const giftText = i18n.t('product_detail_gift_bar', [nickname])
    return { type: 'gift', icon: 'gift.svg', color: 'orange50', text: giftText }
  }

  const getGiftWillExpireNotification = ({ giftExpiredTime }) => {
    const expiredTime = $dayjs(giftExpiredTime).utc().local().format('YYYY/MM/DD HH:mm')
    const diffDays = $dayjs(expiredTime).diff(new Date(), 'day')
    let giftText = ''
    if (diffDays) {
      giftText = i18n.t('gift_expiration_day_hint', [diffDays])
    } else {
      const diffHours = $dayjs(expiredTime).diff(new Date(), 'hour')
      const diffMinute = $dayjs(expiredTime).diff(new Date(), 'minute')
      giftText = diffHours ? i18n.t('gift_expiration_hour_hint', [diffHours]) : i18n.t('gift_expiration_minute_hint', [diffMinute])
    }

    return {
      type: 'giftExpired',
      icon: 'gift.svg',
      fontColor: 'black50',
      iconColor: 'orange50',
      color: 'orange20',
      text: giftText,
      isClosed: true,
      onClick: () => {
        const path = nuxtApp.$localePath({ name: 'gift-list' })
        sessionStorage.setItem('NoGiftExpiration', JSON.stringify({ status: true, dateTime: new Date() }))
        window.location = path
      },
      closed: index => {
        sessionStorage.setItem('NoGiftExpiration', JSON.stringify({ status: true, dateTime: new Date() }))
        store.dispatch('notification/deleteNotification', index)
      },
    }
  }

  const getCanGiftWillExpireNotificationShow = () => {
    const session = JSON.parse(sessionStorage.getItem('NoGiftExpiration'))

    if (session) {
      const isNextDay = session.hasOwnProperty('dateTime') ? $dayjs(session.dateTime).diff(new Date(), 'day') > 0 : true

      if (session.status && !isNextDay) {
        return false
      }
      sessionStorage.removeItem('NoGiftExpiration')
      return true
    }

    return true
  }

  const pushGiftExpiringNotification = userInfo => {
    if (userInfo.unexpired_gift_cnt > 0 && getCanGiftWillExpireNotificationShow()) {
      const giftNotification = getGiftWillExpireNotification({ giftExpiredTime: userInfo.gift_expired_time.time })
      store.dispatch('notification/setNotifications', [giftNotification])
    }
  }

  return {
    getFlashNotification,
    getGroupNotification,
    getDeliveryNotification,
    getGiftNotification,
    pushGiftExpiringNotification,
  }
}

export default notificationComposition
